import { required } from '@vuelidate/validators';
import { Ref } from 'vue';
import { deviceTypes } from '@/enums/device';
import { DeviceClasses } from '@/models/devices/Device';
import { InspectionPoint } from '@/models/inspectionPoint/InspectionPoint';
import i18n from '@/utils/i18n/form.json';

const messages = {
  required: 'Der Wert ist erforderlich',
  invalidDate: 'Das Datum ist ungültig',
  invalidSerialNumber: (device: Ref<DeviceClasses>) => {
    if (device.value.deviceType === deviceTypes.SmartRadiatorThermostat) {
      return i18n.error.invalidFormatSRTSerialNumber;
    } else {
      return i18n.error.invalidFormatSerialNumber;
    }
  },
  invalidManufacturer: (device: Ref<DeviceClasses>) => {
    if (device.value.deviceType === deviceTypes.SmartRadiatorThermostat) {
      return "Zurzeit wird nur der Hersteller 'Tado' unterstützt.";
    }

    return messages.required;
  },
  invalidCustomizedNumber: (value: string) => {
    if (value === '42000') {
      return 'Der Artikel 42000 wird nicht mehr unterstützt.';
    }

    if (value === '42005') {
      return 'Der Artikel 42005 wird nicht mehr unterstützt.';
    }

    return 'Der Wert sollte 5 Ziffern lang sein.';
  },

  invalidInspectionPointCounterPressure: (
    inspectionPoint: Ref<InspectionPoint>
  ) => {
    let maxValue = 90;
    if (
      inspectionPoint.value.accessories.find(
        (accessory) => accessory.customizedNumber === '42051'
      )
    ) {
      maxValue = 80;
    }
    return `Die Eingabe darf 4 Ziffern mit einer Dezimalstelle und einen Wert im Bereich von 0 bis ${maxValue} haben (z. B. 000,0)`;
  },

  invalidEui: `Der Wert sollte 16 Hexadezimalziffern (1-9, A-F) lang sein.`,
  invalidYearOfConformity: `Das Eichjahr sollte 4 Zeichen lang sein (z.B.: 2023)`,
  invalidConstructionYear: `Das Baujahr sollte 4 Zeichen lang sein (z.B.: 1950)`,
  invalidSerialNumberBatteryPack: `Die Seriennummer sollte 12 Zeichen lang sein und dem folgenden Beispielformat entsprechen: MB1234567890`,
  invalidCounterPressure: `Die Eingabe darf 4 Ziffern mit einer Dezimalstelle und einen Wert im Bereich von 0 bis 90 haben (z. B. 000,0)`,
  resetCode: 'Der Code ist 6 Zeichen lang.',
  password: 'Das Passwort muss mindestens 16 Zeichen lang sein.',
  sameAsPassword: 'Die Passwörter stimmen nicht überein.',
  invalidStartDate: `Das Startdatum sollte vor dem Enddatum liegen.`,
  invalidEndDate: `Das Enddatum sollte nach dem Startdatum liegen.`,
  invalidDeviceReference: `Die Seriennummer sollte 8 Zeichen lang sein.`,
  duplicatedSerialNumber: i18n.warning.duplicatedSerialNumber,
};

/*
 * Default messages can be overwritten here
 * for simple validators
 */
required.$message = messages.required;

export { required, messages };
